import { createSlice } from '@reduxjs/toolkit';
import type { User } from "@/libraries/defenitions";

export const userSlice = createSlice({
  name: 'user',
  initialState: {
user: null as User | null,
token: null as string | null,
},
  reducers: {
    addUserInfo: (state, action) => {
      return { ...state, user: { ...state.user, ...action.payload } };
      // state.name = action.payload.name;
      // state.email = action.payload.email;
      // state.school = action.payload.school;
      // state.type = action.payload.type;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    }
  },
});

export const { addUserInfo, setToken } = userSlice.actions;

export default userSlice.reducer;